import { AppProviders } from './providers/AppProviders.tsx'
import { AppRouter } from './router/AppRouter.tsx'
import { AppUpdateNotice } from '@/pwa/AppUpdateNotice.tsx'

export function App() {
  return (
    <AppProviders>
      <AppUpdateNotice />
      <AppRouter />
    </AppProviders>
  )
}
